import { render } from "./NewImprintCard.vue?vue&type=template&id=c4f00ea6"
import script from "./NewImprintCard.vue?vue&type=script&lang=js"
export * from "./NewImprintCard.vue?vue&type=script&lang=js"

import "./NewImprintCard.vue?vue&type=style&index=0&id=c4f00ea6&lang=css"

import exportComponent from "/buddy/vue-imprint-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__